import axios from 'axios'

const ResourceCategoryService = {
  async getList (params = {}) {
    return axios.get('admin/resource-categories', { params })
  },

  async show (id) {
    return axios.get(`admin/resource-categories/${id}`)
  },

  async store (data) {
    return axios.post('admin/resource-categories', data)
  },

  async update (id, data) {
    return axios.put(`admin/resource-categories/${id}`, data)
  },

  async destroy (id) {
    return axios.delete(`admin/resource-categories/${id}`)
  }
}

export default ResourceCategoryService
